/**
 * Client-side homes API module — replaces home.actions.ts Server Actions.
 */

import { HOME, HOME_OWNERS } from "@/shared/constants/backend-api"
import { authFetchJson } from "@/shared/lib/auth-fetch"
import { ApiResponse } from "@/shared/types/backend-response.type"
import { HomeForm1Schema } from "../schema/home/home-form-1.schema"
import { HomeForm2Schema } from "../schema/home/home-form-2.schema"
import { HomeForm3Schema } from "../schema/home/home-form-3.schema"
import { HomeFormSchema, UpdateHomeFormSchema } from "../schema/home/home.schema"

// ---------------------------------------------------------------------------
// Query keys
// ---------------------------------------------------------------------------

export const HOME_QUERY_KEYS = {
  all: ["homes"] as const,
  detail: (homeId: number) => ["homes", "detail", homeId] as const,
}

// ---------------------------------------------------------------------------
// Multi-step creation
// ---------------------------------------------------------------------------

export async function createHomeStep1(
  homeOwnerId: number,
  homeForm1: HomeForm1Schema | HomeFormSchema,
): Promise<ApiResponse> {
  return authFetchJson(HOME.create.step1(homeOwnerId), {
    method: "POST",
    body: JSON.stringify(homeForm1),
  })
}

export async function createHomeStep2(
  homeOwnerId: number,
  homeForm2: HomeForm2Schema | HomeFormSchema,
): Promise<ApiResponse> {
  return authFetchJson(HOME.create.step2(homeOwnerId), {
    method: "POST",
    body: JSON.stringify(homeForm2),
  })
}

export async function createHomeStep3(
  homeOwnerId: number,
  homeForm3: HomeForm3Schema | HomeFormSchema,
): Promise<ApiResponse> {
  return authFetchJson(HOME.create.step3(homeOwnerId), {
    method: "POST",
    body: JSON.stringify(homeForm3),
  })
}

// ---------------------------------------------------------------------------
// Update
// ---------------------------------------------------------------------------

export async function updateHome(
  homeId: number,
  home: UpdateHomeFormSchema,
): Promise<ApiResponse> {
  return authFetchJson(HOME.update(homeId), {
    method: "PATCH",
    body: JSON.stringify(home),
  })
}

export async function updateHomeReportedStatus(
  homeId: number,
  isReported: boolean,
): Promise<ApiResponse> {
  return authFetchJson(HOME.update(homeId), {
    method: "PATCH",
    body: JSON.stringify({ isReported }),
  })
}
